import VueI18n from "vue-i18n";
import App from "./../Pages/AppBase/App.vue";
import { Vue, tlRouter, tlStore } from "../Infrastructure/CorBase/CoreBase"


import translationCS from './BaseLocales/SharedResourcesGLO.cs.json';
import translationEN from './BaseLocales/SharedResourcesGLO.en.json';
import translationDE from './BaseLocales/SharedResourcesGLO.de.json';
import translationSK from './BaseLocales/SharedResourcesGLO.sk.json';


//VaPTODO - az se bude resit lepsi zpusobm routovani tak se spolu s tim zamyslet i nad lepsim zpusobem, jak ho pouzit nez tento hack
//        - viz napr https://github.com/anthonygore/vue-router-user-roles
// VaP -  pokud primo pouziju tlRouter a tlStore, tak to nejde, musim to tu priradit do objektu a ten pak pouzit
let store = tlStore;
let router = tlRouter;


router.beforeEach((to, from, next) => {
	// VaP - zdroj zde https://jasonwatmore.com/post/2018/07/06/vue-vuex-jwt-authentication-tutorial-example#index-js
	
	const loginPage = '/Login';
	const homePage = '/HomePage';
	const passwordChangePage = '/PasswordChange';
	const registrationSelf = '/RegistrationSelf';
	const authRequired = loginPage !== to.path && passwordChangePage !== to.path && registrationSelf !==to.path;
	const loggedIn = store.state.isLogged;

	if (authRequired && !loggedIn) {
		// home page nas nezajima
		if (homePage !== to.path ) {
			store.commit('setLastRoutePage', to.path);
			store.commit('setLastRoutePageQuery', to.query);
		}
		next(loginPage)
	} else {
	//next(); puvodni
		//zpusob obecny - ale jak tu dostat varovnou hlasku 


		//tlStore.state.formIsInEditMode == true ||
		if ( (tlStore.state.mainDataChanged == true || tlStore.state.mainDataChangedSub == true) && from.name != null && tlStore.state.askBeforeCancelEditing === true) {
			if (confirm("Může dojit ke ztrátě neuložených dat. Chcete pokračovat?")) {
				next();
				store.commit('mainDataChanged', false);
				store.commit('mainDataChangedSub', false);
				store.commit('formIsInEditMode', false);
				store.commit('setLastRoutePageQuery', to.query);
			}
			else {
				next(false);
			}
			//Po prvnim zobrazeni nechceme - pokud chceme upozorneni pouze jednou
			//store.commit('mainDataChanged', false);
			//store.commit('mainDataChangedSub', false);
			//store.commit('formIsInEditMode', false);
			//store.commit('setLastRoutePageQuery', to.query);
		}
		else {
			next();
		}
		//TODO dokud se nevyresi zabraneni refresh
		if (from.name == null) {
			store.commit('mainDataChanged', false);
			store.commit('mainDataChangedSub', false);
			tlStore.commit("formIsInEditMode", false);
        }
	}
})


router.afterEach((to, from) => {
	// VaP - zdroj zde https://stackoverflow.com/a/51640162
	let routeTitle: string = 'ivyscreen';
	if (to.meta && to.meta.title) {
		routeTitle = to.meta.title;
	}
	Vue.nextTick(() => {
		document.title = routeTitle;
	});
});

//překlady
const resources = {
	EN: translationEN,
	CS: translationCS,
	DE: translationDE,
	SK: translationSK
};

const i18n = new VueI18n({
	locale: 'CS',
	messages: resources
});

new Vue({
	router,
	store,
	render: h => h(App),
	i18n
}).$mount("#app");
